import api from '@/plugins/request/index';

// 同意审批
export const passApprove = async (params, type = 'put') => {
  return api[type](`/gateway/v1/approval/agree`, params).then(res => res);
}
// 拒绝审批
export const refuseApprove = async (params, type = 'put') => {
  return api[type](`/gateway/v1/approval/reject`, params).then(res => res);
}


//********************报备***************************** */
// 报备审批列表
export const getReportApproList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/apply-list/report', params).then(res => res);
}
// 报备审批处理列表
export const getReportDealList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/handle-list/report', params).then(res => res);
}

// 获取报备审批详情
export const getApproveReportDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/info-report/${id}`, params).then(res => res);
}
// 编辑报备
export const reportApproveEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/edit-report/${id}`, params).then(res => res);
}

//********************带看***************************** */
// 带看审批列表
export const getLookApproList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/apply-list/look', params).then(res => res);
}
// 带看审批处理列表
export const getLookDealList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/handle-list/look', params).then(res => res);
}

// 获取带看审批详情
export const getApproveLookDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/info-look/${id}`, params).then(res => res);
}
// 编辑带看
export const lookApproveEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/edit-look/${id}`, params).then(res => res);
}


//********************认筹***************************** */
// 认筹审批列表
export const getRecognitionApproList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/apply-list/recognition', params).then(res => res);
}
// 认筹审批处理列表
export const getRecognitionDealList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/handle-list/recognition', params).then(res => res);
}

// 获取认筹审批详情
export const getApproveRecognitionDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/info-recognition/${id}`, params).then(res => res);
}
// 编辑认筹
export const recognitionApproveEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/edit-recognition/${id}`, params).then(res => res);
}


//********************认购***************************** */
// 认购审批列表
export const getSubscribeApproList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/apply-list/subscription', params).then(res => res);
}
// 认购审批处理列表
export const getSubscribeDealList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/handle-list/subscription', params).then(res => res);
}

// 获取认购审批详情
export const getApproveSubscribeDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/info-subscription/${id}`, params).then(res => res);
}
// 编辑认购
export const subscribeApproveEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/edit-subscription/${id}`, params).then(res => res);
}


//********************签约***************************** */
// 签约审批列表
export const getSignApproList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/apply-list/sign', params).then(res => res);
}
// 签约审批处理列表
export const getSignDealList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/handle-list/sign', params).then(res => res);
}
// 获取签约审批详情
export const getApproveSignDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/info-sign/${id}`, params).then(res => res);
}
// 编辑签约
export const signApproveEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/edit-sign/${id}`, params).then(res => res);
}


//********************结佣***************************** */
// 结佣审批列表
export const getSettlementApproList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/apply-list/settlement', params).then(res => res);
}
// 结佣审批处理列表
export const getSettlementDealList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/handle-list/settlement', params).then(res => res);
}
// 获取结佣详情
export const getApproveSettlementDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/info-settlement/${id}`, params).then(res => res);
}

// 编辑结佣
export const settlementApproveEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/edit-settlement/${id}`, params).then(res => res);
}

//********************退款***************************** */
// 退款审批列表
export const getRefundApproList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/apply-list/refund', params).then(res => res);
}
// 退款审批处理列表
export const getRefundDealList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/handle-list/refund', params).then(res => res);
}
// 获取退款详情
export const getApproveRefundDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/info-refund/${id}`, params).then(res => res);
}

// 编辑退款
export const refundApproveEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/edit-refund/${id}`, params).then(res => res);
}




//********************锁定***************************** */
// 锁定审批列表
export const getLockApproList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/apply-list/lock', params).then(res => res);
}
// 锁定审批处理列表
export const getLockDealList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/handle-list/lock', params).then(res => res);
}
// 获取锁定详情
export const getApproveLockDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/info-lock/${id}`, params).then(res => res);
}
// 编辑锁定
export const lockApproveEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/edit-lock/${id}`, params).then(res => res);
}

//********************撞客***************************** */
// 撞客审批列表
export const getCollisionApproList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/apply-list/collision', params).then(res => res);
}
// 撞客审批处理列表
export const getCollisionDealList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/handle-list/collision', params).then(res => res);
}
// 获取撞客详情
export const getApproveCollisionDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/info-collision/${id}`, params).then(res => res);
}
// 编辑撞客
export const collisionApproveEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/edit-collision/${id}`, params).then(res => res);
}

//********************合并***************************** */
// 合并审批列表
export const getMergeApproList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/apply-list/merge', params).then(res => res);
}
// 合并审批处理列表
export const getMergeDealList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/handle-list/merge', params).then(res => res);
}
// 获取合并详情
export const getApproveMergeDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/info-merge/${id}`, params).then(res => res);
}
// 编辑合并
export const mergeApproveEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/edit-merge/${id}`, params).then(res => res);
}

//********************无效池***************************** */
// 无效池审批列表
export const getInvalidApproList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/apply-list/invalid', params).then(res => res);
}
// 无效池审批处理列表
export const getInvalidDealList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/handle-list/invalid', params).then(res => res);
}
// 获取无效池详情
export const getApproveInvalidDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/info-invalid/${id}`, params).then(res => res);
}
// 编辑无效池
export const invalidApproveEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/edit-invalid/${id}`, params).then(res => res);
}

//********************黑名单***************************** */
// 黑名单审批列表
export const getBlackApproList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/apply-list/black', params).then(res => res);
}
// 黑名单审批处理列表
export const getBlackDealList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/handle-list/black', params).then(res => res);
}
// 获取黑名单详情
export const getApproveBlackDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/info-black/${id}`, params).then(res => res);
}
// 编辑黑名单
export const blackApproveEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/edit-black/${id}`, params).then(res => res);
}

//********************协助人***************************** */
// 审批列表
export const getHelperApproList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/apply-list/helper', params).then(res => res);
}
// 审批处理列表
export const getHelperDealList = async (params, type = 'get') => {
  return api[type]('/gateway/v1/approval/handle-list/helper', params).then(res => res);
}
// 详情
export const getApproveHelperDetail = async (id, params, type = 'get') => {
  return api[type](`/gateway/v1/approval/info-helper/${id}`, params).then(res => res);
}
// 编辑
export const helperApproveEdit = async (id, params, type = 'put') => {
  return api[type](`/gateway/v1/approval/edit-helper/${id}`, params).then(res => res);
}

/** 获取当前处理的审批次数 */
export const getApproveTotal = async (type = 'get') => {
  return api[type](`/gateway/v1/approval/active-total`, {}, {
    headers: {
      'no-fresh-tag': true
    }
  }).then(res => res);
}
/** 获取审批失败的表单信息 */
export const getFailureApprove = async (params, type = 'get') => {
  return api[type](`/gateway/v1/approval/failure-order-voucher`, params).then(res => res);
}


